import ScoringLayout from "./ScoringLayout";
export default ScoringLayout;
